import type { Shema } from '../api/odjemalec';

/** Koraki izdaje računa in predračuna. */
export type Korak = 'kupec' | 'artikli' | 'storitve' | 'roki' | 'predogled';

export const KORAKI: { kljuc: Korak; naziv: string }[] = [
  { kljuc: 'kupec', naziv: 'Kupec' },
  { kljuc: 'artikli', naziv: 'Artikli' },
  { kljuc: 'storitve', naziv: 'Storitve' },
  { kljuc: 'roki', naziv: 'Roki' },
  { kljuc: 'predogled', naziv: 'Predogled' },
];

/** V katerem koraku je polje z napako strežnika (ime lastnosti zahteve); ostala so v Predogledu. */
const KORAK_POLJA: Record<string, Korak> = {
  kupecId: 'kupec',
  uporabnikVozilaId: 'kupec',
  vozila: 'artikli',
  postavke: 'artikli',
  storitve: 'storitve',
  datum: 'roki',
  rokPlacila: 'roki',
  datumOpravljeneStoritveZacetek: 'roki',
  datumOpravljeneStoritveKonec: 'roki',
  stMesecevGarancije: 'roki',
  veljavnoDni: 'roki',
};

export function korakPolja(polje: string): Korak {
  return KORAK_POLJA[polje] ?? 'predogled';
}

/** Koraki, v katerih so napake (za oznako na koraku). */
export function korakiZNapakami(napake: Record<string, string>): Set<Korak> {
  return new Set(Object.keys(napake).map(korakPolja));
}

/** Prva napaka po vrstnem redu korakov (prikaže se ob gumbih, obrazec skoči na njen korak). */
export function prvaNapaka(napake: Record<string, string>): { polje: string; sporocilo: string } | null {
  const polja = Object.keys(napake);
  for (const k of KORAKI) {
    const polje = polja.find((p) => korakPolja(p) === k.kljuc);
    if (polje) {
      return { polje, sporocilo: napake[polje]! };
    }
  }
  return null;
}

type Klavzula = Shema['KlavzulaPodatki'];

/** Doda klavzule, ki jih še ni (po besedilu), npr. klavzule »za vozilo« ob dodanem vozilu. */
export function dodajKlavzule(obstojece: Klavzula[], nove: Klavzula[]): Klavzula[] {
  const vrni = [...obstojece];
  for (const k of nove) {
    if (k.besedilo && !vrni.some((x) => x.besedilo === k.besedilo)) {
      vrni.push({ id: 0, besedilo: k.besedilo, dodajZaVozilo: !!k.dodajZaVozilo });
    }
  }
  return vrni;
}

/** Število iz vnosa Mantine NumberInput (prazno ali neveljavno → {@code undefined}). */
export function stevilka(v: number | string | null | undefined): number | undefined {
  if (v === '' || v === null || v === undefined) {
    return undefined;
  }
  const n = typeof v === 'number' ? v : Number(String(v).replace(/\./g, '').replace(',', '.'));
  return Number.isFinite(n) ? n : undefined;
}
